import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button 
        className="language-btn"
        onClick={toggleLanguage}
        title={language === 'en' ? 'Switch to French' : 'Passer en anglais'}
      >
        {language === 'en' ? '🇬🇧 EN' : '🇫🇷 FR'}
      </button>
    </div>
  );
};

export default LanguageSwitcher;